import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import axios from 'axios';

const NewsletterPosts = () => {
  const [newsletters, setNewsletters] = useState([]);
  const [post, setPost] = useState([]);
  const [nextPost, setNextPost] = useState('');
  const [prevPost, setPrevPost] = useState('');
  const [searchParams] = useSearchParams();
  const postBase = '/newsletter-post?post=';

  useEffect(() => {
    axios.get('/api/news?post=all').then(response => {
      setNewsletters(response.data);
      const postIndex = response.data.findIndex(object => {
        return object.id === searchParams.get('post');
      });
      if (postIndex !== response.data.length - 1) {
        setNextPost(postBase + response.data[postIndex + 1].id);
      }
      if (postIndex !== 0) {
        setPrevPost(postBase + response.data[postIndex - 1].id);
      }
    }).catch(error => {
      console.log(error);
    });
  }, [setNewsletters, searchParams, setNextPost, setPrevPost]);

  useEffect(() => {
    axios.get('/api/news?post=' + searchParams.get('post')).then(response => {
      setPost(response.data);
    }).catch(error => {
      console.log(error);
    });
  }, [setPost, searchParams]);

  const formatPostDate = (postDate) => {
    // don't do this kids, I just don't want to fix the timezone shit
    const date = new Date((parseInt(postDate, 10) + 29000) * 1000);
    const options = { month: 'long' };
    const monthName = date.toLocaleDateString(undefined, options);
    return monthName + ' ' + date.getDate() + ", " + date.getFullYear();
  };

  return (
    <section className="section-padding all-blog2 bg-one header-padding">
      <div className="container">
        <div className="row">
          <div
            id="right"
            className="col-md-5 col-lg-4 col-xl-3"
            data-aos="fade-right"
            data-aos-duration="1000"
            data-aos-delay="200"
          >
            <div className="all-blog2__sidebar">
              <div className="all-blog2__sidebar__archive item-border">
                <h2 className="fs-4 mb-3"><Link to='/newsletter-archive'>Archives</Link></h2>
                <ul>
                  {newsletters.map((newsletter) => (
                    <li key={newsletter.date}>
                      <Link reloadDocument to={'/newsletter-post?post=' + newsletter.id}>{formatPostDate(newsletter.date)}</Link>&nbsp;
                    </li>
                  ))}
                </ul>
              </div>
              <div className="all-blog2__sidebar__social item-border">
                <h2 className="fs-4 mb-3">Social</h2>
                <ul className="social-icon my-4">
                  <li>
                    <a href="https://instagram.com/jutefoster" target="_blank" rel="noopener noreferrer" >
                      <img
                        className="img-fluid"
                        src="assets/icons/Instagram_Glyph_White.svg"
                        alt="icon"
                        width="25"
                        height="25"
                      />
                    </a>
                  </li>
                  <li>
                    <a href="https://discord.gg/JUcBUxuYUd" target="_blank" rel="noopener noreferrer">
                      <img
                        className="img-fluid"
                        src="assets/icons/Discord-Symbol-White.svg"
                        alt="icon"
                        width="25"
                        height="25"
                      />
                    </a>
                  </li>
                  <li>
                    <a href="https://facebook.com/jutefoster" target="_blank" rel="noopener noreferrer">
                      <img
                        className="img-fluid"
                        src="assets/icons/facebook.svg"
                        alt="icon"
                        width="25"
                        height="25"
                      />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div
            className="col-md-7 col-lg-8 col-xl-9 mb-4 mb-md-0"
            data-aos="fade-right"
            data-aos-duration="1000"
            data-aos-delay="200"
          >
            {/* {prevPost && <Link reloadDocument to={prevPost}>← Previous post</Link>}
            {nextPost && <Link reloadDocument to={nextPost}>Next post →</Link>} */}
            <div dangerouslySetInnerHTML={{ __html: post.htmlContents }} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default NewsletterPosts;